<template>
	<div>
			<h1 class="account-page-padding">Dashboard</h1>
				<div v-show="errors.error" class="account-page-padding">
					<div  class="notification notification-error">
						<p class="paragraph-details"><strong>Error:</strong> {{ errors.error }}</p>
					</div>
				</div>
				
				<!-- RECENT ORDER -->
				<div class="recent-order-container account-page-padding" v-if="order && canPlaceOrders">
					<div class="recent-order-header">
						<h3>Most Recent Order</h3>
						<Link :href="route('account.orders')">View All Orders</Link>
					</div>
					<div class="recent-order-details">
						<div class="main-order-info">
							<h4 class="order-number" v-if="order.code">Order #{{ order.code }}</h4>
							<div class="order-date" v-if="orderDate">
								<p class="label">Order Date:</p>
								<p> {{ orderDate }}</p>
							</div>
							<div class="order-total" v-if="order.total">
								<p class="label">Total:</p>
								<p> {{ formatPriceAsString(order.total) }}</p>
							</div>
						</div>
						<p class="order-status text-inStockGreen" v-if="order.status">Order {{order.status}}</p>
						<div class="order-products">
							<div class="image-container" v-for="(item, index) of orderItemImages" :key="`recent_order_item_${index}`">
                                <media v-bind="item.props" />
							</div>
							<div v-if="order.count > 5" class="more-products bg-rothcoRed text-rothcoWhite">+{{ order.count - 5 }}</div>
                            <div v-else-if="order.count > 4">+{{ order.count - 4 }}</div>
						</div>
						<div class="ctas-container">
							<button v-if="order.tracking_number" @click="trackOrder(order)" class="secondary" id="track-order">
								Track Order
								<div aria-label="hidden" class="icon">
									<CarretsBlackIcon alt="arrow right"/>
								</div>
							</button>
							<Link as="button" :href="route('order.details', [order.order_id])" class="primary" ref="viewDetails">View Details
								<div aria-label="hidden" class="icon">
									<CarretsBlackIcon alt="arrow right"/>
								</div>
							</Link>
						</div>
					</div>

				</div>
				<!-- MANAGE ACCOUNT -->
				<div class="manage-account-container account-page-padding">
					<h3>Manage Account</h3>
					<div v-if="isB2B && resaleCertificateWarningMessages.length && (uploadMessage.text == '' || uploadMessage.text == null )" class="manage-account-warning bg-rothcoRed text-rothcoWhite">
						<div class="flex-row justify-center align-center">
							<div class="flex-column" style="padding-right: 1rem;">
								<span v-for="(msg,i) of resaleCertificateWarningMessages" :key="i" style="text-align: left;">{{msg}}</span>
							</div>
							<UploadResaleCertificate v-model:upload-message="uploadMessage" class="text-rothcoWhite">Upload now</UploadResaleCertificate>
						</div>
					</div>
					<div v-else-if="isB2B && resaleCertificateWarningMessages.length && uploadMessage?.text?.length > 0" 
						:class="{'manage-account-warning':true, 'notification-success': uploadMessage.success, 'notification-error': !uploadMessage.success}"> 
						<span>{{ uploadMessage?.text }}{{ uploadMessage?.text?.endsWith(".") ? "" : "." }}</span>&nbsp;<UploadResaleCertificate v-if="!uploadMessage.success" v-model:upload-message="uploadMessage" class="text-rothcoWhite">Try again</UploadResaleCertificate>

					</div>
					<div v-if="isB2B && resaleCertificates.length" class="manage-account-warning bg-rothcoBlack text-rothcoWhite">
						<span>{{ resaleCertificates.length }}  Reseller Certificate(s) on file. <a @click.prevent="showResaleCertificates()" class="text-rothcoWhite">Click to View</a></span>
					</div>
					<!-- B2B Links -->
					<div class="manage-account-links" id="dealer-account-links" v-if="isB2B">
						<Link v-if="canPlaceOrders" as="button" :href="route('account.paymentMethods')" class="secondary grey" id="manage_credit_cards_button">
							<div class="button-section">
								<p>Credit Cards</p>
								<p>Manage your cards on file</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<Link v-if="canHandleAdmin" as="button" :href="route('account.companyInfo')" class="secondary grey">
							<div class="button-section">
								<p>Company Info</p>
								<p>View or edit your information</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<Link v-if="canSeePricing" as="button" :href="route('account.orders')" class="secondary grey">
							<div class="button-section">
								<p>Order History</p>
								<p>View all previous purchase details</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<Link v-if="canPlaceOrders" as="button" :href="route('account.paymentHistory')" class="secondary grey">
							<div class="button-section">
								<p>Payment History</p>
								<p>See all purchases for your organization</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<Link v-if="canHandleAdmin" as="button" :href="route('account.accounts')" class="secondary grey">
							<div class="button-section">
								<p>User Accounts</p>
								<p>Manage your organization’s accounts</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<Link as="button" :href="route('account.lists')" class="secondary grey">
							<div class="button-section">
								<p>Saved Lists</p>
								<p>View, edit, or purchase your lists</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<Link as="button" :href="route('account.passwordSecurity')" class="secondary grey">
							<div class="button-section">
								<p>Password & Security</p>
								<p>Edit your password & 2FA settings</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
					</div>
					<!-- D2C Links -->
					<div class="manage-account-links" id="consumer-account-links" v-else>
						<Link as="button" :href="route('account.profile')" class="secondary grey" id="manage_credit_cards_button">
							<div class="button-section">
								<p>Profile</p>
								<p>Manage name and contact information</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<Link :href="route('account.addresses')" style="text-decoration: none; width: 100%">
							<button class="secondary grey" id="manage_credit_cards_button">
								<div class="button-section">
									<p>Addresses</p>
									<p>Add or edit your shipping addresses</p>
								</div>
								<div class="button-section icon" aria-label="hidden">
									<CarretsBlackIcon alt="arrow right"/>
								</div>
							</button>
						</Link>
						<Link :href="route('account.paymentMethods')" style="text-decoration: none; width: 100%">
							<button :href="route('account.paymentMethods')" class="secondary grey" id="manage_credit_cards_button">
								<div class="button-section">
									<p>Payments</p>
									<p>Add or edit payment methods</p>
								</div>
								<div class="button-section icon" aria-label="hidden">
									<CarretsBlackIcon alt="arrow right"/>
								</div>
							</button>
						</Link>
						<Link as="button" :href="route('account.passwordSecurity')" class="secondary grey">
							<div class="button-section">
								<p>Password & Security</p>
								<p>Edit your password & 2FA settings</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<Link as="button" :href="route('account.orders')" class="secondary grey">
							<div class="button-section">
								<p>Order History</p>
								<p>View and manage all open & past orders</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<UploadResaleCertificate
							tag="button" class="secondary grey"
							v-model:upload-message="uploadMessageTaxExemption" 
						>
							<div v-if="customer.tax_exempt == 1" class="button-section">
								<p>Tax Exemption Form</p>
								<p class="text-inStockGreen">Your tax exemption status has been approved!</p>
								<p :class="{
									'success-message': uploadMessageTaxExemption?.success === true,
									'error-message': uploadMessageTaxExemption?.success === false
								}">{{uploadMessageTaxExemption?.text ? uploadMessageTaxExemption?.text : 'Click to re-submit your tax exemption form'}} </p>
							</div>
							<div v-else class="button-section">
								<p>Tax Exemption Form</p>
								<p :class="{
									'success-message': uploadMessageTaxExemption?.success === true,
									'error-message': uploadMessageTaxExemption?.success === false
								}">{{uploadMessageTaxExemption?.text ? uploadMessageTaxExemption?.text : 'Click to submit your tax exemption form'}} </p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</UploadResaleCertificate>
					</div>
				</div>
				<!-- API PORTAL -->
				<div class="api-portal-container account-page-padding" v-if="isB2B">
					<h3>API Portal</h3>
					<!-- Portal Settings -->
					<div class="api-portal-links">
						<Link as="button" :href="route('account.apiPortal')" class="secondary grey">
							<div class="button-section">
								<p>Portal Settings</p>
								<p>Configure API</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
						<!-- API Documentation -->
						<Link as="button" :href="route('api.docs', ['about-the-api'])" class="secondary grey">
							<div class="button-section">
								<p>API Documentation</p>
								<p>API guides, tools, and specifications</p>
							</div>
							<div class="button-section icon" aria-label="hidden">
								<CarretsBlackIcon alt="arrow right"/>
							</div>
						</Link>
					</div>
					<!-- API PORTAL ACCESS-->
					<!-- <div class="api-portal-access-container bg-rothcoCream">
						<div class="api-portal-access-content">
							<h4>API Portal Access</h4>
							<p>Access live inventory updates, new product listings, automatic order entry, trends and
								insights, rich product data & specifications, and more, making selling Rothco products
								and boosting your sales easier than ever.</p>
							<!-- Request api portal access --
							<Link as="button" :href="route('account.apiPortal')" class="primary">
								Request API portal access
								<div aria-label="hidden" class="icon">
									<CarretsBlackIcon alt="arrow right"/>
								</div>
							</Link>
						</div>
					</div> -->
				</div>
				<!-- FAVORITES-->
				<div v-if="hasFavorites" class="account-page-padding">
					<div class="favorites-container">
						<h3>Favorites</h3>
						<Link :href="route('account.favorites')">View All & Manage</Link>
					</div>
				</div>
				<!-- CAROUSEL-->
				<product-carousel
					:togglePadding="true"
					v-if="hasFavorites"
					ref="productCarouselRef"
				/>

				<!-- RECOMMENDED ITEMS -->
				<div class="account-page-padding">
					<div class="manage-account-container">
						<h3>Recommended For You</h3>
					</div>
				</div>
				<ProductCarousel boost-tag="home-page-session"/>

				<!-- NEED HELP-->
				<div class="need-help-container account-page-padding">
					<h3>Need Help?</h3>
					<div class="need-help-links">
						<Link v-if="isB2B" class="learn-more" :href="route('customer-service.faqs')" aria-label="Learn more about Rothco’s Dealer Portal">
							<LearnMoreIcon alt="Learn more" />
							<span>Learn More About Rothco’s Dealer Portal</span>
						</Link>
						<Link class="support-center" :href="route('customer-service.index')" aria-label="Visit the Support Center">
							<SupportHeadsetIcon alt="Support headset" />
							<span>Support Center</span>
						</Link>
					</div>
				</div>
			</div>
</template>
<script lang="ts" setup>
    import { type PropType, ref, toRefs, computed, onMounted, inject } from "vue";
    import { type Order } from "@/helpers/interfaces/OrderInterfaces";
    import { useDateFormat } from "@vueuse/core";
    import Media from "@/components/Media.vue";
    import { Link, usePage} from "@inertiajs/vue3";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
	import ProductCarousel from "@/components/ProductCarousel.vue";
	import ViewResaleCertificates from "@/components/ViewResaleCertificates.vue"
	import UploadResaleCertificate from "@/components/UploadResaleCertificate.vue";
	import { useFavoritesStore } from "@/store/favorites";
	import { formatPriceAsString } from "@/helpers/composables/usePriceFormatting";
	import CarretsBlackIcon from "@icons/carrets-black.svg";
	import LearnMoreIcon from "@icons/learn-more.svg";
	import SupportHeadsetIcon from "@icons/support-headset.svg";
	import { useDialog } from "primevue/usedialog";
	import { comingSoonImages } from "@/helpers/composables/comingSoonImages"
	import {
		productUploadImageResponsiveFromFilename,
		PRODUCT_IMAGE_SIZES_ORDER_TILE
	} from "@/helpers/productUploadImageUrl";

	const dialog = useDialog();
	let route = inject("route");
	let store = useSettingsStore();
    let { user, canSeePricing, canPlaceOrders, canHandleAdmin } = storeToRefs(store);
    let isB2B = computed(() => user.value.is_dealer);
    
	
	interface Customer {
        customer_id: string;
        tax_exempt: number;
        resale_certificates: Array<Object>;
		missing_exposure_zones: Array<String>;
    }

    let orderDate = computed(() => {
        if (order.value.created_at === null) {
            return "";
        }
        let date = useDateFormat(
            order.value.created_at,
            "MM/DD/YYYY"
        ).value.replace(/\"/g, "");
        return date;
    });

	
    let orderItemImages = computed(() => {
        return order.value.order_items.slice(0, 4).map((item, index) => {
            const fn = item?.item_variation?.primary_image?.image_filename;
            if (!fn) {
                return {
                    item: item?.item_variation?.b2b_identifier ?? item.name,
                    props: {
                        defaultMediaType: "image",
                        alt: item.item_variation?.b2b_identifier,
                        media: comingSoonImages().small
                    }
                };
            }
            const pack = productUploadImageResponsiveFromFilename(
                fn,
                PRODUCT_IMAGE_SIZES_ORDER_TILE
            );
            return {
                item: item?.item_variation?.b2b_identifier ?? item.name,
                props: {
                    defaultMediaType: "image",
                    alt: item.item_variation?.b2b_identifier,
                    media: pack.src,
                    srcSet: pack.srcSet,
                    sizes: pack.sizes
                }
            };
        });
    });
    let props = defineProps({
        order: {
            type: Object as PropType<Order>,
            default: () => ({
                order_items: []
            })
        },
        customer: {
            type: Object as PropType<Customer>,
            default: () => ({
                customer_id: "",
                tax_exempt: 0,
                resale_certificates: [],
				missing_exposure_zones: []
            })
        }
    });
    let { order, customer } = toRefs(props);

	let errors = computed(()=>{
		return usePage().props.errors ?? {};
	})

	const resaleCertificates = computed(()=>{
		return props.customer.resale_certificates && Array.isArray(props.customer.resale_certificates) ? props.customer.resale_certificates : [];
	})
	const hasResaleCertificates = computed(()=>{
		return resaleCertificates.value.length > 0
	})
	const missingExposureZones = computed(()=>{
		return props.customer.missing_exposure_zones && Array.isArray(props.customer.missing_exposure_zones) ? props.customer.missing_exposure_zones : [];
	})
	const resaleCertificateWarningMessages = computed(()=>{
		let msgArr = [];
		if(!hasResaleCertificates.value){
			msgArr.push("We don’t have a resale certificate on file for you. ");
		} 
		if(missingExposureZones.value?.length){
			msgArr.push(`Missing resale certificate(s) for the following states: ${missingExposureZones.value.join(", ")} `);
		}
		return msgArr;
	})

	onMounted(() => {
		if (isB2B.value) {
			// store.getCustomer();
		}
	});


	let uploadMessage = ref({});

	let uploadMessageTaxExemption = ref({});


	function trackOrder(order: Order) {
		window.open(order.tracking_url, "_blank");
	}


	let favoritesStore = useFavoritesStore();

	let { hasFavorites } = storeToRefs(favoritesStore);

	const showResaleCertificates = ()=>{
		dialog.open(ViewResaleCertificates, {
            props: {
                showHeader: false,
				modal: false
            },
            data: {
                resaleCertificates: resaleCertificates.value
            },
            onClose: (props) => {

            }
        })
	}
	
</script>
